import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from '../../../utils';
import type {
  GetCompanyCodeTranslationQuery,
  GetCompanyCodeTranslationQueryVariables,
  CreateCompanyCodeTranslationMutation,
  CreateCompanyCodeTranslationMutationVariables,
  CreateCompanyCodeTranslationArrayMutation,
  CreateCompanyCodeTranslationArrayMutationVariables,
} from '../../../graphql';
import { createCompanyCodeTranslation, createCompanyCodeTranslationArray, getCompanyCodeTranslation } from '../../../graphql';
import { RTK_CACHE_LIFETIME } from '../../../config';
import type { TDSOptions } from '../types';

export const companyCodeTranslationApi = createApi({
  reducerPath: 'companyCodeTranslationApi',
  baseQuery: baseQuery,
  tagTypes: ['companyCodeTranslation', 'companyCodeTranslationArrayTDS'],
  endpoints: (builder) => ({
    getTDSOptions: builder.query<TDSOptions[], GetCompanyCodeTranslationQueryVariables>({
      query: (variables) => ({ body: getCompanyCodeTranslation, variables }),
      keepUnusedDataFor: RTK_CACHE_LIFETIME,
      providesTags: ['companyCodeTranslation'],
      transformResponse: (response: GetCompanyCodeTranslationQuery, m, variables) => {
        if (variables?.codetype === '1' || variables?.codetype === '2') {
          // TDS (codetype '1') or TCS (codetype '2')
          const transformedData =
            response?.getCompanyCodeTranslation?.map((item) => {
              const cv = item?.codevalue;
              const percentage =
                cv === null || cv === undefined || cv === ''
                  ? ''
                  : (() => {
                      const n = Number(cv);
                      return Number.isFinite(n) ? String(n) : '';
                    })();
              return {
                label: item?.codetext || '',
                // Some newly-created rows may have empty `section` initially; use codeorder fallback.
                value: item?.section || (item?.codeorder != null ? String(item.codeorder) : ''),
                percentage,
                codeorder: item?.codeorder ?? undefined,
                raw:item
              };
            }) || [];
          return transformedData;
        }
        return [];
      },
    }),
    createCompanyCodeTranslation: builder.mutation<CreateCompanyCodeTranslationMutation, CreateCompanyCodeTranslationMutationVariables>({
      query: (variables) => ({
        body: createCompanyCodeTranslation,
        variables,
      }),
      invalidatesTags: ['companyCodeTranslation'],
    }),
    createCompanyCodeTranslationArray: builder.mutation<
      CreateCompanyCodeTranslationArrayMutation,
      CreateCompanyCodeTranslationArrayMutationVariables
    >({
      query: (variables) => ({
        body: createCompanyCodeTranslationArray,
        variables,
      }),
      invalidatesTags: ['companyCodeTranslation'],
    }),
  }),
});

export const {
  useGetTDSOptionsQuery,
  useLazyGetTDSOptionsQuery,
  usePrefetch,
  useCreateCompanyCodeTranslationMutation,
  useCreateCompanyCodeTranslationArrayMutation,
} = companyCodeTranslationApi;
